<div class="data-picker-container">
  <button
    class="itemData"
    style="z-index: 1000"
    [disabled]="diabledButtonWeek||disabled"
    (click)="beforeClick()"
    mat-mini-fab color="primary">
    <mat-icon>navigate_before</mat-icon>
  </button>
  <div>
    @if (rangeData) {
      @if (!!currentDate.toDate!&&!!currentDate.fromDate!;) {
        <mat-card
          [ngClass]="{'disabled-card':disabled}"
          (click)="openPicker(picker)"
          class="spacerw5"
          style="cursor:pointer;font-weight: bold;border-radius: 50px;min-width: 80px;text-align: center"
          >
          <mat-card-content class="color-contrast-theme">
            @switch (typeDate) {
              @case ('deltaYear') {
                {{currentDate.fromDate!|hunaDate:'custom':'yyyy'|async}}
              }
              @case ('deltaMonth') {
                {{currentDate.fromDate!|hunaDate:'custom':'MMMM'|async}}
                ,  {{currentDate.fromDate!|hunaDate:'custom':'yyyy'|async}}
              }
              @default {
                {{currentDate.fromDate!|hunaDate:'mediumDate':'noYear'|async}}
                - {{currentDate.toDate!|hunaDate:'mediumDate':'noYear'|async}}
                ,  {{currentDate.toDate!|hunaDate:'custom':'yyyy'|async}}
              }
            }
          </mat-card-content>
        </mat-card>
      }
      <div style="z-index: -10000 ;max-width: 0px;max-height: 0px;margin-left: -50px;opacity: 0">
        <mat-date-range-input
          style="z-index: -10000 ;width: 0px"
          [max]="today"
          [formGroup]="rangeForm"
          [rangePicker]="picker"
          >
          <input matStartDate formControlName="start">
          <input matEndDate formControlName="end">
        </mat-date-range-input>
        <mat-datepicker-toggle
          style="z-index: -10000 ;width: 0px;"
          matSuffix [for]="picker">
        </mat-datepicker-toggle>
        <mat-date-range-picker
          (closed)="closePicker()"
          style="z-index: -10000 ;width: 0px"
          #picker
          >
        </mat-date-range-picker>
        <!--                <mat-date-range-picker-->
        <!--                        (closed)="closePicker()"-->
        <!--                        style="z-index: -10000 ;width: 0px"-->
        <!--                        #picker-->
        <!--                        appRangeDate [maxRange]="deltaDate"-->
        <!--                >-->
      <!--                </mat-date-range-picker>-->
    </div>
  } @else {
    <div style="z-index: -10000 ;max-width: 0px;max-height: 0px;margin-left: -50px;opacity: 0">
      <ng-container [formGroup]="rangeForm">
        <input matInput formControlName="end" [matDatepicker]="picker" [max]="today">
        <mat-datepicker-toggle
        matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker
        #picker></mat-datepicker>
      </ng-container>
    </div>
    @if (!!currentDate.toDate!&&!!currentDate.fromDate!;) {
      <mat-card [ngClass]="{'disabled-card':disabled}"
        (click)="openPicker(picker)"
        class="spacerw5" style="cursor:pointer;font-weight: bold;border-radius: 50px"
        >
        <mat-card-content class="color-contrast-theme">
          {{currentDate.toDate!|hunaDate:'mediumDate':'noYear'|async}}
          ,  {{currentDate.toDate!|hunaDate:'custom':'yyyy'|async}}
        </mat-card-content>
      </mat-card>
    }
  }
</div>
<button class="itemData"
  (click)="nextClick();"
  [disabled]="diabledButtonWeek||disableNextWeek||disabled"
  mat-mini-fab color="primary">
  <mat-icon>navigate_next</mat-icon>
</button>
</div>